<template>
    <div class="wrapper-body flex-1">
        <ListCorrespondences :nodeId="nodeId" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'ArchiveView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 0,
            }
        },
        mounted () 
        {
            this.nodeId = 8
        },
	}
</script>